import mixpanel from "mixpanel-browser";

const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
let initialized = false;

export const initMixpanel = () => {
  if (!token || initialized) return;

  mixpanel.init(token, {
    debug: process.env.NODE_ENV !== "production",
    persistence: "localStorage",
    track_pageview: true,
  });
  initialized = true;
};

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (!token) {
    return;
  }
  if (!initialized) {
    initMixpanel();
  }
  mixpanel.track(eventName, properties);
};

export const identifyUser = (walletAddress?: string) => {
  if (!walletAddress || !token) return;
  if (!initialized) {
    initMixpanel();
  }
  mixpanel.identify(walletAddress);
};
